import Chip from '@/components/ui/Chip';
import { RESTOCKING_STATUS_LABELS } from '@/constants/app/restocking';
import { RestockRequestStatus } from '@/types/generated/boro';

type Props = {
  status: string;
};

const COLORS = {
  [RestockRequestStatus.Created]: 'warning',
  [RestockRequestStatus.Fulfilled]: 'warning',
  [RestockRequestStatus.Loaded]: 'info',
  [RestockRequestStatus.PendingReconcile]: 'warning',
  [RestockRequestStatus.Completed]: 'success',
  [RestockRequestStatus.Cancelled]: 'error',
} as const;

const RestockingStatus = ({ status }: Props) => {
  return (
    <Chip
      color={COLORS[status] ?? 'default'}
      label={RESTOCKING_STATUS_LABELS[status] ?? 'Unknown'}
      sx={{ mx: 'auto', fontWeight: 'bold', fontSize: '12px' }}
    />
  );
};

export default RestockingStatus;
